module.exports = __webpack_public_path__ + "static/media/step-3.7c7380a0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BuyForMe/icons/step-3.svg
 ** module id = 877
 ** module chunks = 0
 **/